import { buildExamModal, hideExamModal } from "../../Utils/utils";
import { examHolder, jumpToTask, takeStep } from "../Exam";

export function addExamListeners(){
    const holder = $(examHolder);

    holder.on("click", ".next-task", function(e){
        e.preventDefault()
        takeStep(1);
    })

    holder.on("click", ".previous-task", function(e){
        e.preventDefault()
        takeStep(-1);
    })

    holder.on("click", ".jump", function(){
        const tab = Number($(this).attr('data-to'));
        jumpToTask(tab);
    })

    holder.on("click", ".open-losung", function(){
        $(this).next().toggleClass("d-none");
    })

}


function playSound(el:JQuery){
    const url = el.data("audio");
    const a = new Audio(url);
    a.addEventListener('ended', () => {
        $(this).find('i').removeClass('fa-volume-up').addClass('fa-volume-down');
    });
    a.addEventListener('play', () => {
        $(this).find('i').removeClass('fa-volume-down').addClass('fa-volume-up');
    });
    a.volume = 0.65;
    a.play();
}

function showPopup(el:JQuery){
    const text = el.data("text");
    const seconds = el.data("sek");
    buildExamModal(text);

    // show
    setTimeout(() => {
        hideExamModal();
    }, seconds * 1000);
}